<ng-container *ngIf="showNotesIcon">
    <ng-container *ngIf="hasNotes === true">
        <i [title]="title" class="cc-hyperlink cc-icon-check" [ngClass]="iconNotes" (click)="onClick()"></i>
    </ng-container>
    <ng-container *ngIf="hasNotes === false">
        <i
            [title]="title"
            class="cc-hyperlink dx-theme-accent-as-text-color"
            [ngClass]="iconEmptyNotes"
            (click)="onClick()"
        ></i>
    </ng-container>
</ng-container>
